__turbopack_context__.v({
  "no-qr-code": "ErrorPage-module-scss-module__DLf6Jq__no-qr-code",
  "qr-wrapper": "ErrorPage-module-scss-module__DLf6Jq__qr-wrapper",
  "wrapper": "ErrorPage-module-scss-module__DLf6Jq__wrapper",
});
